export const cbFunctions = {
    /**
     * @param response
     * @property response.initial_risk
     */
    'fillRecommendation': function (response) {
        console.log('fillRecommendation');
        $.each(response, function (index, value) {
            let element = $('#' + index + '_field');

            if (element) {
                element.text(value);
                element.siblings('input').val(value);
            }
        });

        const risk = $('#risk_field').val();
        $('button[data-risk="' + risk + '"]').addClass('active');
        $('#editGridFormSubmit').removeClass('disabled');

        if (response.initial_risk > response.stability) {
            const stabilityField = document.getElementById('stability_field').parentElement;

            if (stabilityField) {
                stabilityField.classList.add('bg-danger');
                document.getElementById('gridAlert').classList.remove('d-none');
            }
        }
    },
    "fillDeposit": function (data) {
        $.each(data, function(index, value) {
            let selector = '[data-deposit="' + index + '"]';
            $(selector).text(value);
        });
    },
    "showPosition": function (data) {
        let $block = $('#positionInfo');

        $block.DataTable({
            "data": [data],
            "columns": [
                { "data": "symbol" },
                { "data": "entryPrice" },
                { "data": "markPrice" },
                { "data": "positionAmt" },
                { "data": "unRealizedProfit" },
                { "data": "liquidationPrice" },
                { "data": null,
                    render: () => {
                        return `<a target="_blank" href="/admin/users/orders/${this.data.id}">Orders</a>`;
                    }}
            ],
            paging: false,
            searching: false,
            ordering:  false,
            info: false,
            destroy: true
        });
        $block.removeClass('d-none');
        $('html, body').animate({
            scrollTop: $("#positionInfo").offset().top
        }, 2000);
    }
};

export const getters = {
    'getRecommendation': function (data) {
        $('button[data-risk="' + data.risk + '"]').addClass(['disabled', 'spin-it']);
        $('#risk_field').val(data.risk);
        $('button[data-risk]').removeClass('active');
        $('#gridAlert').addClass('d-none');
        $('#stability_field').parent().removeClass('bg-danger');

        if (data.risk === 'manual') {
            return getters.toggleManual(data);
        } else {
            getters.toggleManual(false);
        }

        return {
            'deposit': $('#deposit_field').siblings('input').val(),
            'risk': data.risk,
            'liquidation': 0,
            'startAmt': 0,
            'stability': 0,
            'market': 0,
        };
    },
    'getLiquidation': function () {
        return {
            'deposit': $('#deposit_field').siblings('input').val(),
            'risk': 'manual',
            'liquidation': 0,
            'startAmt': $('#amount_field').siblings('input').val(),
            'stability': 0,
            'market': 0,
        };
    },
    'toggleManual': function (data) {
        let amount_field = $('#amount_field');
        let delay_field = $('#delay_field');

        if (data === false) {
            amount_field.show();
            delay_field.show();
            amount_field.siblings('input').prop('type', 'hidden');
            delay_field.siblings('input').prop('type', 'hidden');
            $('#editGridFormSubmit').removeClass('disabled');
            $('#editGridFormCalc').addClass('d-none');
        } else {
            amount_field.hide();
            delay_field.hide();
            amount_field.siblings('input').prop('type', 'text');
            delay_field.siblings('input').prop('type', 'text');
            $('button[data-risk="manual"]').addClass('active');
            $('#editGridFormSubmit').addClass('disabled');
            $('#editGridFormCalc').removeClass('d-none');
        }

        return false;
    },
    'getStatus': function (data) {
        return {
            id: data.id,
            status: $(`select[data-id=${data.id}]`).val()
        };
    }
};

export const completer = {
    'getRecommendation': () => {
        $('button[data-risk]').removeClass(['disabled', 'spin-it']);
    }
}
